/**
 * TermsConditions Component
 */
(function () {
    'use strict';

    /**
     * TermsConditions details form
     * @name termsConditionsCtrl
     * @type ItxTermsConditionsCmpCtrl
     * @param {object} termsConditionsForm  Objeto donde tenemos el formulario angular
     * @param {string} sections secciones que se quieren mostrar
     * @param {string} prefix prefijo a añadir para poner id
     */
    var TermsConditionsCmp = {
        bindings: {
            termsConditionsForm: '=',
            sections: '<',
            prefix: '<',
            model: '=',
            order: '<',
            preselected: '<'
        },
        controller: TermsConditionsCmpCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'terms-conditions.component.html'
    };

    TermsConditionsCmpCtrl.$inject = [
        'ngDialog',
        'imTrackingCommonService',
        'imEventServiceWrapper',
        '$scope',
        'rgpdService',
        'ItxGiftCardSvc',
        'ItxTranslateSvc',
        'ItxStaticResourceSvc',
        'CmsConfigSvc',
        '$sce',
        'preCommonCmsConfigSvc'
    ];

    function TermsConditionsCmpCtrl( // jshint ignore:line
        ngDialog,
        imTrackingCommonService,
        imEventServiceWrapper,
        $scope,
        rgpdService,
        ItxGiftCardSvc,
        ItxTranslateSvc,
        ItxStaticResourceSvc,
        CmsConfigSvc,
        $sce,
        preCommonCmsConfigSvc
    ) {
        var _this = this;
        var t = inditex.text;
        var lineTerms;
        var namePrivacy = 'privacyPolicyAccepted';
        var translatePrivacyPolicy = ItxTranslateSvc.translateCms('legacy.privacy_policy');

        _this.arrLineTerms = [];
        _this.idRandom = _.uniqueId('terms_');
        _this.termsData = null;
        _this.isCountryFeel = false;

        /**
         * Modelo para crear componentes de Términos y servicios
         */
        function PrivacyPolicyBase() {
            this.key = namePrivacy;
            this.required = true;
            this.tooltipMode = false;
            this.twoTerms = false;
            this.model = namePrivacy;
            this.showNgMessage = true;

            return this;
        }

        _this.$onInit = function () {
            inditex.onReady(function () {
                _this.optIn = inditex.xconf['NEWSLETTER_DOUBLE_OPT_IN'] === '1' ? true : false;
                _this.isChina = inditex.iCountryCode.toLowerCase() === 'cn';

                if (!_this.model) {
                    _this.model = {};
                }
                rgpdService.isRgpdEnabled().then((res) => {
                    _this.rgpdEnabled = res;
                    _this.isMobile = inditex.isMobileDevice();
                    _this.isTurkey = inditex.iCountryCode === 'TR' || inditex.iCountryCode === 'TK';
                    _this.isKorea = inditex.iCountryCode === 'KR';
                    _this.isKoreanLang = inditex.iLangId === -9;
                    _this.guestUser = inditex.iUserJSON.userType === 'G';

                    ItxTranslateSvc.waitTranslations().then(() => {
                        if (_this.rgpdEnabled) {
                            _this.generateLineTermsRGPD();
                            if (!_this.isMobile && _this.arrLineTerms[0].tooltipMode) {
                                rgpdService
                                    .getContentExcel(_this.arrLineTerms[0].layer)
                                    .then(function (data) {
                                        _this.termsData = data;
                                    })
                                    .catch(function (err) {
                                        console.log(err);
                                    });
                            }
                        } else {
                            _this.generateLineTerms();
                        }
                    });
                });

                preCommonCmsConfigSvc.getProperty('is_country_feel').then(function (crmActive) {
                    _this.isCountryFeel = crmActive;
                });
            });
        };

        _this.checkDirtyAndSubmitted = function (lineTerms) {
            return _this.termsConditionsForm[lineTerms.key].$dirty || _this.termsConditionsForm.$submitted;
        };

        _this.checkDirtyAndSubmittedAndRequired = function (lineTerm) {
            return (
                _this.termsConditionsForm.$submitted &&
                _this.termsConditionsForm[lineTerm.key] &&
                _this.termsConditionsForm[lineTerm.key].$error &&
                _this.termsConditionsForm[lineTerm.key].$error.required
            );
        };

        // Tipos de vista
        _this.purchaseConditions = hasSection('purchaseConditions');
        _this.newsletterConditions = hasSection('newsletterConditions');
        _this.newsletterConditionsAccount = hasSection('newsletterConditionsAccount');
        _this.giftCardConditions = hasSection('giftCardConditions');
        _this.registerConditions = hasSection('registerConditions');
        _this.socialConditions = hasSection('socialConditions');
        _this.addressConditions = hasSection('addressConditions');
        _this.hideTermsNewsletter = hasSection('hideTermsNewsletter');
        _this.hidePrivacyPolicy = hasSection('hidePrivacyPolicy');
        _this.productStatusConditions = hasSection('productStatusConditions');
        _this.storageOfPaymentConditions = hasSection('storageOfPaymentConditions');
        _this.giftCardConditionsReturn = hasSection('giftCardConditionsReturn');
        _this.contactConditions = hasSection('contactConditions');
        _this.feelRegisterConditions = hasSection('feelRegisterConditions');
        _this.onlyPrivacyPolicy = hasSection('onlyPrivacyPolicy');

        _this.isSummary = function () {
            return inditex.iPage === 'ItxCheckoutPage' && location.hash === '#/summary';
        };

        // En Korea podemos aceptar todos los términos a la vez

        _this.checkTermsAll = function () {
            // _this.model = _this.model || {};
            if (_this.termsAll) {
                // if(_this.rgpdEnabled){
                //     rgpdService.openPopup();
                // }
                _this.model.privacyPolicyAccepted = true;
                _this.model.newsletterAccepted = true;
                _this.model.termsConditions = true;
                _this.model.termsConditionsUnder14 = true;
            } else {
                _this.model.privacyPolicyAccepted = false;
                _this.model.newsletterAccepted = false;
                _this.model.termsConditions = false;
                _this.model.termsConditionsUnder14 = false;
            }
        };

        _this.openPrivacyPolicy = function (layer) {
            if (_this.rgpdEnabled && layer != 'NO_LAYER') {
                if (_this.isMobile || (!_this.isMobile && !_this.arrLineTerms[0].tooltipMode)) {
                    rgpdService.openPopup(layer);
                }
            } else {
                _this.windowOpenPrivacyPolicy();
            }
        };

        _this.windowOpenPrivacyPolicy = function () {
            imTrackingCommonService.sendTerms();
            window.open(
                inditex.getStaticResourceUrl('pdf/privacy_policy/' + inditex.iStoreId + '/privacy_policy' + inditex.iLangId + '.pdf'),
                '_blank'
            );
        };

        _this.windowOpenFeelPrivacyPolicy = function () {
            imTrackingCommonService.sendTerms();
            if (_this.isChina) {
                window.open(
                    inditex.getStaticResourceUrl('pdf/privacy_policy/' + inditex.iStoreId + '/privacy_policy' + inditex.iLangId + '.pdf'),
                    '_blank'
                );
            } else {
                window.open(
                    inditex.getStaticResourceUrl('pdf/privacy_policy_feel/' + inditex.iStoreId + '/privacy_policy_feel' + inditex.iLangId + '.pdf'),
                    '_blank'
                );
            }
        };

        /**
         * Función para abrir el PDF de términos y condiciones de Feel
         */
        _this.windowOpenFeelTermsConditions = function () {
            imTrackingCommonService.sendTerms();

            if (_this.isChina) {
                window.open(
                    inditex.getStaticResourceUrl('pdf/feel_conditions/' + inditex.iStoreId + '/feel_conditions' + inditex.iLangId + '.pdf'),
                    '_blank'
                );
            } else {
                window.open(
                    inditex.getStaticResourceUrl(
                        'pdf/terms_conditions_feel/' + inditex.iStoreId + '/terms_conditions_feel' + inditex.iLangId + '.pdf'
                    ),
                    '_blank'
                );
            }
        };

        _this.isCheckedTerms = function (lineTerm) {
            if (!_this.isMobile && !_this.arrLineTerms[0].tooltipMode) {
                if (lineTerm.model === 'privacyPolicyAccepted' && _this.rgpdEnabled && _this.model.privacyPolicyAccepted) {
                    if (lineTerm.layer !== 'NO_LAYER') {
                        rgpdService.openPopup(lineTerm.layer);
                    }
                }
            }
            if (
                lineTerm.model === 'privacyPolicyFeel' &&
                _this.model.feelRequired &&
                _this.rgpdEnabled &&
                _this.isCountryFeel &&
                !_this.model.privacyPolicyFeel
            ) {
                rgpdService.openMemberGetMemberFeelWarningPopUp();
            }
            if (
                lineTerm.model === 'newsletterAccepted' &&
                _this.model.newsletterRequired &&
                !_this.isCountryFeel &&
                !_this.model.newsletterAccepted
            ) {
                rgpdService.openMemberGetMemberNewsletterWarningPopUp();
            }
        };

        _this.openCancellationPolicies = function () {
            window.open(
                inditex.getStaticResourceUrl('pdf/cancelation_right/' + inditex.iStoreId + '/cancelation_right' + inditex.iLangId + '.pdf'),
                '_blank'
            );
        };

        _this.openPurchaseCondition = function () {
            imEventServiceWrapper.sendBasicAnalytics('legal', 'resumen_compra', 'ver_condiciones_compra');
            rgpdService.openPurchaseCondition();
        };

        _this.openGiftCardConditions = function () {
            ItxGiftCardSvc.openPopupTerms();
        };

        _this.openKoreaPersonalInformation = function () {
            _this.openSpotInfo('KR_Terms_Policy');
        };

        _this.openKoreaPersonalInformationNewsletter = function () {
            _this.openSpotInfo('KR_Terms_Email');
        };

        _this.openKoreaPersonalInformationOverseas = function () {
            _this.openSpotInfo('KR_Terms_Conditions');
        };

        _this.openSpotInfo = function (spot) {
            ngDialog.open({
                template: [
                    '<div class="container-dialog">',
                    '<div class="content">',
                    '<itx-marketing-spot name="{{ngDialogData.spot}}"><itx-marketing-spot>',
                    '</div>',
                    '</div>'
                ].join(' '),
                className: 'ngdialog-theme-plain policy-dialog',
                plain: true,
                showClose: true,
                data: {
                    spot: spot
                }
            });
        };

        // SI NO TENEMOS RGPD HABILITADO
        _this.generateLineTerms = function () {
            _this.model.newsletterAccepted = _this.model.newsletterRequired && !_this.isCountryFeel ? true : false;
            if (_this.productStatusConditions) {
                // terms-conditions-contact.tpl.html
                lineTerms = {
                    key: 'privacyPolicyAccepted',
                    required: true,
                    model: 'privacyPolicyAccepted',
                    customErrorMessage: t('ItxNewsLetterContactView.alta.politica.validacion'),
                    clickText2: _this.openPrivacyPolicy,
                    messages: {}
                };

                if (_this.optIn) {
                    lineTerms.messages.text1 = ItxTranslateSvc.translateCms('legacy.ItxNewslettersView.msgpolicy1.optIn');
                    lineTerms.messages.text2 = ItxTranslateSvc.translateCms('legacy.ItxNewslettersView.msgpolicy2.optIn');
                    lineTerms.messages.text3 = ItxTranslateSvc.translateCms('legacy.ItxNewslettersView.msgpolicy3.optIn');
                } else {
                    lineTerms.messages.text1 = t('ItxContactPopup.privacy_policy_text');
                    lineTerms.messages.text2 = translatePrivacyPolicy;
                }
                _this.arrLineTerms.push(lineTerms);
            }

            if (_this.registerConditions || _this.addressConditions || _this.socialConditions || _this.contactConditions) {
                //POR DEFECTO EN TODOS...
                if (!_this.isKorea && !_this.hidePrivacyPolicy) {
                    lineTerms = {
                        key: 'privacyPolicyAccepted',
                        required: true,
                        model: 'privacyPolicyAccepted',
                        customErrorMessage: ItxTranslateSvc.translateCms('legacy.ItxNewsLetterContactView.alta.politica.validacion'),
                        clickText2: _this.openPrivacyPolicy,
                        messages: {}
                    };

                    if (_this.optIn) {
                        lineTerms.messages.text1 = ItxTranslateSvc.translateCms('legacy.ItxUserRegistrationForm.msgpolicy2.optIn');
                        lineTerms.messages.text2 = ItxTranslateSvc.translateCms('legacy.ItxUserRegistrationForm.msgpolicy3.optIn');
                    } else {
                        lineTerms.messages.text1 = ItxTranslateSvc.translateCms('legacy.ItxUserRegistrationForm.msgpolicy2');
                        lineTerms.messages.text2 = ItxTranslateSvc.translateCms('legacy.ItxUserRegistrationForm.msgpolicy3');
                    }
                    _this.arrLineTerms.push(lineTerms);
                }
                //SI ES KOREA
                if (_this.isKorea) {
                    _this.generateLinetermKorea();
                } else if (!_this.hideTermsNewsletter) {
                    lineTerms = {
                        key: 'newsletter',
                        model: 'newsletterAccepted',
                        messages: {}
                    };

                    // if (_this.optIn) {
                    lineTerms.messages.text1 = ItxTranslateSvc.translateCms('legacy.ItxUserRegistrationForm.msginfo.newsletter.OptIn');
                    // } else {
                    //     lineTerms.messages.text1 = ItxTranslateSvc.translateCms('legacy.ItxUserRegistrationForm.msginfo');
                    // }
                    _this.arrLineTerms.push(lineTerms);
                }
            }
            if (_this.storageOfPaymentConditions) {
                lineTerms = {
                    key: 'saveCard',
                    required: false,
                    model: 'saveCard',
                    messages: { text1: ItxTranslateSvc.translateCms('legacy.ItxCheckoutView.payment.card.saveCard') }
                };
                _this.arrLineTerms.push(lineTerms);
            }

            if (_this.giftCardConditions || _this.giftCardConditionsReturn) {
                lineTerms = {
                    key: 'giftCardAccepted',
                    required: true,
                    model: 'giftCardAccepted',
                    showNgMessage: true,
                    clickText2: _this.openGiftCardConditions,
                    clickText4: _this.openPrivacyPolicy,
                    customErrorMessage: ItxTranslateSvc.translateCms('legacy.ItxNewsLetterContactView.alta.politica.validacion'),
                    messages: {
                        text1: ItxTranslateSvc.translateCms('legacy.ItxGiftCardView.acepto'),
                        text2: ItxTranslateSvc.translateCms('legacy.ItxGiftCardView.condicionesUsoTr'),
                        text3: ItxTranslateSvc.translateCms('legacy.ItxOrderPaymentPage.and'),
                        text4: ItxTranslateSvc.translateCms('legacy.ItxOrderPaymentPage.policies')
                    }
                };
                _this.arrLineTerms.push(lineTerms);
            }

            if (_this.purchaseConditions) {
                // NO TURKO
                if (!_this.isTurkey) {
                    lineTerms = {
                        key: 'termsConditionsCheckout',
                        required: true,
                        model: 'termsConditionsCheckout',
                        customErrorMessage: ItxTranslateSvc.translateCms('legacy.ItxNewsLetterContactView.alta.politica.validacion'),
                        clickText2: _this.openPurchaseCondition,
                        clickText4: _this.openPrivacyPolicy
                    };

                    if (!_this.isKoreanLang) {
                        // NO KOREANO
                        lineTerms.messages = {
                            text1: ItxTranslateSvc.translateCms('legacy.ItxOrderPaymentPage.accept'),
                            text2: ItxTranslateSvc.translateCms('legacy.purchase_conditions'),
                            text3: ItxTranslateSvc.translateCms('legacy.ItxOrderPaymentPage.and'),
                            text4: ItxTranslateSvc.translateCms('legacy.ItxOrderPaymentPage.policies')
                        };
                    } else {
                        // TEXTO EN COREANO
                        lineTerms.messages = {
                            text2: ItxTranslateSvc.translateCms('legacy.purchase_conditions'),
                            text3: ItxTranslateSvc.translateCms('legacy.ItxOrderPaymentPage.and'),
                            text4: ItxTranslateSvc.translateCms('legacy.ItxOrderPaymentPage.policies'),
                            text5: ItxTranslateSvc.translateCms('legacy.ItxOrderPaymentPage.accept')
                        };
                    }
                    _this.arrLineTerms.push(lineTerms);
                } else {
                    // POLITICAS DE TURQUIA

                    lineTerms = {
                        key: 'privacyAndCancellation',
                        required: true,
                        model: 'privacyAndCancellation',
                        customErrorMessage:
                            ItxTranslateSvc.translateCms('legacy.Messages_politicaPrivacidad') +
                            ' ' +
                            ItxTranslateSvc.translateCms('legacy.ItxOrderPaymentPage.and') +
                            ' ' +
                            ItxTranslateSvc.translateCms('legacy.ItxOrderPaymentPage.cancellationPolicies'),
                        externalScrollContent: 'CancellationPolicy',
                        clickText2: _this.openPrivacyPolicy,
                        clickText4: _this.openCancellationPolicies,
                        messages: {
                            text1: ItxTranslateSvc.translateCms('legacy.ItxOrderPaymentPage.accept'),
                            text2: ItxTranslateSvc.translateCms('legacy.ItxOrderPaymentPage.policies'),
                            text3: ItxTranslateSvc.translateCms('legacy.ItxOrderPaymentPage.and'),
                            text4: ItxTranslateSvc.translateCms('legacy.ItxOrderPaymentPage.cancellationPolicies')
                        }
                    };
                    _this.arrLineTerms.push(lineTerms);

                    lineTerms = {
                        key: 'termsConditionsCheckout',
                        required: true,
                        model: 'termsConditionsCheckout',
                        customErrorMessage: ItxTranslateSvc.translateCms('legacy.Messages_aceptarCondicionesCompra'),
                        externalScrollContent: 'TermsAndConditions',
                        messages: {
                            text1:
                                ItxTranslateSvc.translateCms('legacy.ItxOrderPaymentPage.accept') +
                                ' ' +
                                ItxTranslateSvc.translateCms('legacy.ItxOrderPaymentPage.conditions')
                        }
                    };
                    _this.arrLineTerms.push(lineTerms);

                    lineTerms = {
                        key: 'distantSale',
                        required: true,
                        model: 'distantSale',
                        customErrorMessage: ItxTranslateSvc.translateCms('legacy.ItxUserRegistrationForm.acceptAllConditionsKO'),
                        externalScrollContent: 'DistantSaleContractContentWeb',
                        extrernalScrollContentCompile: true,
                        messages: {
                            text1:
                                ItxTranslateSvc.translateCms('legacy.ItxOrderPaymentPage.accept') +
                                ' ' +
                                ItxTranslateSvc.translateCms('legacy.ItxOrderPaymentPage.distantSalesContract')
                        },
                        data: {
                            Itxc: _this.model.Itxc,
                            shopCart: inditex.iUserJSON.shopCart,
                            formatPrice: inditex.formatPrice.bind(inditex)
                        }
                    };
                    if (_this.order) {
                        var addressId;
                        if (!_this.order.shipping.shippingData.addressId) {
                            addressId = inditex.iUserJSON.primaryAddressId;
                        } else {
                            addressId = _this.order.shipping.shippingData.addressId;
                        }
                        joyr.rest.xRestGetAddressInfo(addressId).done(function (address) {
                            if (!address) {
                                lineTerms.data.address = address;
                            } else {
                                lineTerms.data.address = _this.model.billingAddress;
                            }
                            lineTerms.data.shippingAddress = address;

                            _this.arrLineTerms.push(lineTerms);

                            $scope.$apply();
                        });
                    } else {
                        _this.arrLineTerms.push(lineTerms);
                    }
                }
            }

            if (_this.newsletterConditions || _this.newsletterConditionsAccount) {
                if (_this.isKorea) {
                    _this.showTermsAll = true;
                    // INPUT 1
                    lineTerms = new PrivacyPolicyBase();
                    lineTerms.clickText2 = _this.openKoreaPersonalInformation;
                    lineTerms.messages = {
                        text2: t('ItxContactPopup.terms_policy')
                    };
                    _this.arrLineTerms.push(lineTerms);
                    // INPUT 2
                    lineTerms = {
                        key: 'termsConditions',
                        required: true,
                        model: 'termsConditions',
                        showNgMessage: true,
                        clickText2: _this.openKoreaPersonalInformationOverseas,
                        messages: {
                            text2: t('ItxContactPopup.terms_conditions')
                        }
                    };
                    _this.arrLineTerms.push(lineTerms);
                } else {
                    lineTerms = new PrivacyPolicyBase();
                    lineTerms.clickText2 = _this.openPrivacyPolicy;
                    lineTerms.messages = {
                        text1: ItxTranslateSvc.translateCms('legacy.ItxNewslettersView.msgpolicy1.optIn'),
                        text2: translatePrivacyPolicy,
                        text3: ItxTranslateSvc.translateCms('legacy.ItxNewslettersView.msgpolicy3.optIn')
                    };
                    _this.arrLineTerms.push(lineTerms);
                }
            }

            // Términos y condiciones para Feel
            if (_this.feelRegisterConditions) {
                lineTerms = new PrivacyPolicyBase();
                lineTerms.layer = 'layer_2';
                lineTerms.model = 'privacyPolicyFeel';
                lineTerms.clickText2 = _this.windowOpenFeelTermsConditions;
                lineTerms.clickText4 = _this.windowOpenFeelPrivacyPolicy;

                // Para China la construcción de los términos es diferente
                if (_this.isChina) {
                    const legalText = ItxTranslateSvc.translateCmsWithoutParams('dev.identity.register.feel.legalDisclaimer');
                    const splittedLegalText = legalText.split(/{{ \$\d }}/);

                    lineTerms.messages = {
                        text1: splittedLegalText[0],
                        text2: ItxTranslateSvc.translateCms('dev.general.useConditions'),
                        text3: splittedLegalText[1],
                        text4: ItxTranslateSvc.translateCms('dev.general.privacyPolicy'),
                        text5: splittedLegalText[2]
                    };
                } else {
                    lineTerms.messages = {
                        text1: ItxTranslateSvc.translateCms('legacy.rgpd.RegisterFeel_1'),
                        text2: ItxTranslateSvc.translateCms('legacy.rgpd.RegisterFeel_2'),
                        text3: ItxTranslateSvc.translateCms('legacy.rgpd.RegisterFeel_3'),
                        text4: translatePrivacyPolicy,
                        text5: ItxTranslateSvc.translateCms('legacy.rgpd.RegisterFeel_5')
                    };
                }

                _this.arrLineTerms.push(lineTerms);

                if (!_this.hideTermsNewsletter && !_this.isChina) {
                    // INPUT 2
                    lineTerms = {
                        key: 'termsNewsletter',
                        model: 'newsletterAccepted',
                        tooltipMode: false,
                        messages: {
                            text1: ItxTranslateSvc.translateCms('legacy.rgpd.RegisterNewsletter_1')
                        }
                    };
                    _this.arrLineTerms.push(lineTerms);
                }
            }
        };

        /**
         * Función para generar los Términos y condiciones con RGPD habilitado
         */
        _this.generateLineTermsRGPD = function () {
            _this.model.newsletterAccepted = _this.model.newsletterRequired && !_this.isCountryFeel ? true : false;
            // ID WORD = 2, 11
            if (_this.registerConditions || _this.contactConditions) {
                // INPUT 1
                lineTerms = new PrivacyPolicyBase();
                lineTerms.clickText2 = _this.openPrivacyPolicy;
                lineTerms.tooltipMode = true;
                lineTerms.messages = {
                    text1: ItxTranslateSvc.translateCms('legacy.rgpd.Register_1'),
                    text2: translatePrivacyPolicy,
                    text3: ItxTranslateSvc.translateCms('legacy.rgpd.Register_3')
                };

                lineTerms.layer = 'layer_2';
                if (_this.contactConditions) {
                    lineTerms.layer = 'layer_11';
                }
                _this.arrLineTerms.push(lineTerms);

                // Comprobamos si el servicio de Massimo Dutti Feel está activo
                CmsConfigSvc.getProperty('is_country_feel').then(function (crmActive) {
                    // Términos y condiciones para darse de alta en Massimo Dutti Feel en el formulario de registro
                    if (crmActive) {
                        if (_this.registerConditions) {
                            // Obtén los textos traducidos
                            CmsConfigSvc.getTranslation('forms.termsConditions.feel').then(function (translation) {
                                // Construye los términos a presentar
                                const feelLineTerms = new PrivacyPolicyBase();
                                feelLineTerms.key = 'privacyPolicyFeel';
                                feelLineTerms.model = 'privacyPolicyFeel';
                                feelLineTerms.showNgMessage = false;
                                feelLineTerms.tooltipMode = false;
                                feelLineTerms.required = false;
                                _this.model.privacyPolicyFeel = _this.model.feelRequired ? true : false;

                                // Acciones de los enlaces
                                feelLineTerms.clickText2 = _this.windowOpenFeelTermsConditions;
                                feelLineTerms.clickText4 = _this.windowOpenFeelPrivacyPolicy;

                                // Textos
                                feelLineTerms.messages = {
                                    image: ItxStaticResourceSvc.getStatic() + '/media/2019/crm/web/LOGO_MD_FEEL_XS.png',
                                    textImage: translation + ' ',
                                    text1: ItxTranslateSvc.translateCms('legacy.rgpd.RegisterFeel_1'),
                                    text2: ItxTranslateSvc.translateCms('legacy.rgpd.RegisterFeel_2'),
                                    text3: ItxTranslateSvc.translateCms('legacy.rgpd.RegisterFeel_3'),
                                    text4: translatePrivacyPolicy + '.'
                                };
                                if (!(_this.preselected && _this.preselected.feelTermsAndConditions)) {
                                    _this.arrLineTerms.push(feelLineTerms);
                                }

                                // Añade los términos y condiciones para las Newsletter
                                if (!_this.hideTermsNewsletter) {
                                    // INPUT 2
                                    lineTerms = {
                                        key: 'termsNewsletter',
                                        model: 'newsletterAccepted',
                                        tooltipMode: false,
                                        messages: {
                                            text1: ItxTranslateSvc.translateCms('legacy.rgpd.RegisterNewsletter_1')
                                        }
                                    };
                                    if (!(_this.preselected && _this.preselected.newsletterSections)) {
                                        _this.arrLineTerms.push(lineTerms);
                                    }
                                }
                            });
                        }
                        // Si Massimo Dutti Feel no está activo, añadimos los términos de Newsletter
                    } else {
                        // Añade los términos y condiciones para las Newsletter
                        if (!_this.hideTermsNewsletter) {
                            // INPUT 2
                            lineTerms = {
                                key: 'termsNewsletter',
                                model: 'newsletterAccepted',
                                tooltipMode: false,
                                messages: {
                                    text1: ItxTranslateSvc.translateCms('legacy.rgpd.RegisterNewsletter_1')
                                }
                            };
                            _this.arrLineTerms.push(lineTerms);
                        }
                    }
                });
            }

            // ID WORD = Feel no contemplado en el WORD de RGPD
            if (_this.feelRegisterConditions) {
                // INPUT 1
                lineTerms = new PrivacyPolicyBase();
                lineTerms.model = 'privacyPolicyFeel';
                lineTerms.clickText2 = _this.windowOpenFeelTermsConditions;
                lineTerms.clickText4 = _this.windowOpenFeelPrivacyPolicy;
                lineTerms.messages = {
                    text1: ItxTranslateSvc.translateCms('legacy.rgpd.RegisterFeel_1'),
                    text2: ItxTranslateSvc.translateCms('legacy.rgpd.RegisterFeel_2'),
                    text3: ItxTranslateSvc.translateCms('legacy.rgpd.RegisterFeel_3'),
                    text4: translatePrivacyPolicy,
                    text5: ItxTranslateSvc.translateCms('legacy.rgpd.RegisterFeel_5')
                };

                lineTerms.layer = 'layer_2';
                _this.arrLineTerms.push(lineTerms);

                if (!_this.hideTermsNewsletter) {
                    // INPUT 2
                    lineTerms = {
                        key: 'termsNewsletter',
                        model: 'newsletterAccepted',
                        tooltipMode: false,
                        messages: {
                            text1: ItxTranslateSvc.translateCms('legacy.rgpd.RegisterNewsletter_1')
                        }
                    };
                    _this.arrLineTerms.push(lineTerms);
                }
            }

            // ID WORD = 1a
            if (_this.newsletterConditions) {
                lineTerms = new PrivacyPolicyBase();
                lineTerms.layer = 'layer_1';
                lineTerms.clickText2 = _this.openPrivacyPolicy;
                lineTerms.messages = {
                    // No veo traducciones de esto
                    text1: getStoreTranslation('rgpd.NewsletterConditionsV1_1'),
                    text2: translatePrivacyPolicy,
                    // no veo traducciones de esto
                    text3: getStoreTranslation('rgpd.NewsletterConditionsV1_3')
                };
                _this.arrLineTerms.push(lineTerms);
            }

            // ID WORD = 1b
            if (_this.newsletterConditionsAccount) {
                lineTerms = new PrivacyPolicyBase();
                lineTerms.layer = 'layer_1';
                lineTerms.clickText2 = _this.openPrivacyPolicy;
                lineTerms.messages = {
                    // no veo traducciones de esto
                    text1: getStoreTranslation('rgpd.NewsletterConditionsV2_1'),
                    text2: translatePrivacyPolicy,
                    // no veo traducciones de esto
                    text3: getStoreTranslation('rgpd.NewsletterConditionsV2_3')
                };
                _this.arrLineTerms.push(lineTerms);
            }

            // ID WORD: 4, 5(N/A)
            if (_this.productStatusConditions) {
                // abre la capa 4
                lineTerms = new PrivacyPolicyBase();
                lineTerms.layer = 'layer_4';
                lineTerms.clickText2 = _this.openPrivacyPolicy;
                lineTerms.messages = {
                    text1: getStoreTranslation('rgpd.ProductStatus_1'),
                    text2: translatePrivacyPolicy,
                    text3: getStoreTranslation('rgpd.ProductStatus_3')
                };
                _this.arrLineTerms.push(lineTerms);
            }

            // ID WORD: 6a, 6b
            if (_this.purchaseConditions || _this.addressConditions) {
                lineTerms = new PrivacyPolicyBase();
                if (_this.guestUser) {
                    if (_this.purchaseConditions) {
                        // ID WORD: 6a
                        lineTerms.layer = 'layer_6A';
                        lineTerms.clickText2 = _this.openPurchaseCondition;
                        lineTerms.clickText4 = _this.openPrivacyPolicy;
                        lineTerms.twoTerms = true;
                        lineTerms.tooltipMode = true;
                        lineTerms.customErrorMessage = ItxTranslateSvc.translateCms('legacy.ItxNewsLetterContactView.alta.politica.validacion');
                        lineTerms.messages = {
                            text1: ItxTranslateSvc.translateCms('legacy.rgpd.Purchase_1'),
                            text2: ItxTranslateSvc.translateCms('legacy.purchase_conditions'),
                            text3: ItxTranslateSvc.translateCms('legacy.rgpd.Purchase_3'),
                            text4: translatePrivacyPolicy,
                            text5: ItxTranslateSvc.translateCms('legacy.rgpd.Purchase_5')
                        };
                    } else {
                        // ID WORD: 6a
                        lineTerms.layer = 'layer_6A';
                        lineTerms.clickText2 = _this.openPrivacyPolicy;
                        lineTerms.customErrorMessage = ItxTranslateSvc.translateCms('legacy.ItxNewsLetterContactView.alta.politica.validacion');
                        lineTerms.messages = {
                            text1: ItxTranslateSvc.translateCms('legacy.rgpd.PurchaseGuest_1'),
                            text2: translatePrivacyPolicy,
                            text3: ItxTranslateSvc.translateCms('legacy.rgpd.PurchaseGuest_3')
                        };
                    }
                } else {
                    // ID WORD: 6b
                    lineTerms.layer = 'NO_LAYER';

                    lineTerms.clickText2 = _this.openPurchaseCondition;
                    lineTerms.clickText4 = _this.windowOpenPrivacyPolicy;
                    lineTerms.customErrorMessage = ItxTranslateSvc.translateCms('legacy.ItxNewsLetterContactView.alta.politica.validacion');
                    lineTerms.messages = {
                        text1: ItxTranslateSvc.translateCms('legacy.rgpd.Purchase_1'),
                        text2: ItxTranslateSvc.translateCms('legacy.purchase_conditions'),
                        text3: ItxTranslateSvc.translateCms('legacy.rgpd.Purchase_3'),
                        text4: translatePrivacyPolicy,
                        text5: ItxTranslateSvc.translateCms('legacy.rgpd.Purchase_5')
                    };
                }
                _this.arrLineTerms.push(lineTerms);
            }

            // ID WORD: 7
            if (_this.giftCardConditions) {
                // abrir la capa 7
                lineTerms = new PrivacyPolicyBase();
                lineTerms.layer = 'layer_7';
                lineTerms.clickText2 = _this.openGiftCardConditions;
                lineTerms.clickText4 = _this.openPrivacyPolicy;
                lineTerms.messages = {
                    text1: ItxTranslateSvc.translateCms('legacy.rgpd.GiftCard_1'),
                    text2: ItxTranslateSvc.translateCms('legacy.ItxGiftCardView.condicionesUsoTr'),
                    text3: ItxTranslateSvc.translateCms('legacy.rgpd.GiftCard_3'),
                    text4: translatePrivacyPolicy,
                    text5: ItxTranslateSvc.translateCms('legacy.rgpd.GiftCard_5')
                };
                _this.arrLineTerms.push(lineTerms);
            }

            // ID WORD: 8
            if (_this.giftCardConditionsReturn) {
                lineTerms = new PrivacyPolicyBase();
                lineTerms.layer = 'layer_8';
                lineTerms.clickText2 = _this.openPurchaseCondition;
                lineTerms.clickText4 = _this.openPrivacyPolicy;
                lineTerms.messages = {
                    text1: ItxTranslateSvc.translateCms('legacy.rgpd.Purchase_1'),
                    text2: ItxTranslateSvc.translateCms('legacy.purchase_conditions'),
                    text3: ItxTranslateSvc.translateCms('legacy.rgpd.Purchase_3'),
                    text4: translatePrivacyPolicy,
                    text5: ItxTranslateSvc.translateCms('legacy.rgpd.Purchase_5')
                };
                _this.arrLineTerms.push(lineTerms);
            }

            // ID 12
            if (_this.storageOfPaymentConditions) {
                lineTerms = new PrivacyPolicyBase();
                lineTerms.key = 'saveCard';
                lineTerms.required = false;
                lineTerms.model = 'saveCard';
                lineTerms.layer = 'layer_12';
                lineTerms.clickText2 = _this.openPrivacyPolicy;
                lineTerms.messages = {
                    text1: ItxTranslateSvc.translateCms('legacy.rgpd.StorageOfPayment_1'),
                    text2: translatePrivacyPolicy,
                    text3: ItxTranslateSvc.translateCms('legacy.rgpd.StorageOfPayment_3')
                };
                _this.arrLineTerms.push(lineTerms);
            }

            // ID 3
            if (_this.socialConditions) {
                // INPUT 1
                lineTerms = new PrivacyPolicyBase();
                lineTerms.layer = 'layer_3';
                lineTerms.clickText2 = _this.openPrivacyPolicy;
                lineTerms.messages = {
                    text1: getStoreTranslation('rgpd.SocialLogin_1'),
                    text2: translatePrivacyPolicy,
                    text3: getStoreTranslation('rgpd.SocialLogin_3')
                };
                _this.arrLineTerms.push(lineTerms);
                // INPUT 2
                lineTerms = {
                    key: 'termsNewsletter',
                    required: false,
                    model: 'newsletterAccepted',
                    messages: {
                        text1: ItxTranslateSvc.translateCms('legacy.rgpd.RegisterNewsletter_1')
                    }
                };
                _this.arrLineTerms.push(lineTerms);
            }

            // Casuística para mostrar solo la política de privacidad
            if (_this.onlyPrivacyPolicy) {
                lineTerms = {
                    key: 'privacyPolicyAccepted',
                    required: true,
                    model: 'privacyPolicyAccepted',
                    customErrorMessage: t('ItxNewsLetterContactView.alta.politica.validacion'),
                    clickText2: _this.openPrivacyPolicy,
                    messages: {
                        text1: ItxTranslateSvc.translateCms('legacy.rgpd.Register_1'),
                        text2: translatePrivacyPolicy
                    }
                };

                _this.arrLineTerms.push(lineTerms);

                // Añade los términos y condiciones para las Newsletter
                if (!_this.hideTermsNewsletter) {
                    lineTerms = {
                        key: 'termsNewsletter',
                        model: 'newsletterAccepted',
                        tooltipMode: false,
                        messages: {
                            text1: ItxTranslateSvc.translateCms('legacy.rgpd.RegisterNewsletter_1')
                        }
                    };

                    _this.arrLineTerms.push(lineTerms);
                }
            }
        };

        _this.generateLinetermKorea = function () {
            _this.showTermsAll = true;

            lineTerms = new PrivacyPolicyBase();
            lineTerms.clickText2 = _this.openKoreaPersonalInformation;
            lineTerms.messages = {
                text2: ItxTranslateSvc.translateCms('legacy.ItxContactPopup.terms_policy')
            };
            _this.arrLineTerms.push(lineTerms);

            lineTerms = {
                key: 'termsNewsletter',
                model: 'newsletterAccepted',
                clickText2: _this.openKoreaPersonalInformationNewsletter,
                messages: {
                    text2: ItxTranslateSvc.translateCms('legacy.ItxContactPopup.terms_email_kr')
                }
            };
            _this.arrLineTerms.push(lineTerms);

            lineTerms = {
                key: 'termsConditions',
                required: true,
                model: 'termsConditions',
                showNgMessage: true,
                clickText2: _this.openKoreaPersonalInformationOverseas,
                messages: {
                    text2: ItxTranslateSvc.translateCms('legacy.ItxContactPopup.terms_conditions')
                }
            };
            _this.arrLineTerms.push(lineTerms);

            lineTerms = {
                key: 'termsConditionsUnder14',
                required: true,
                model: 'termsConditionsUnder14',
                showNgMessage: true,
                messages: {
                    text2: ItxTranslateSvc.translateCms('dev.register.under14Condition')
                }
            };
            _this.arrLineTerms.push(lineTerms);
        };

        // PRIVATE SECTIONS
        function hasSection(name) {
            _this.sectionsArray = _this.sections ? _this.sections.split(',') : [];
            return _this.sectionsArray.indexOf(name) > -1;
        }

        function getStoreTranslation(name) {
            var res = ItxTranslateSvc.translate(name);
            // ALEMANIA
            if (inditex.iCountryCode === 'DE') {
                res = ItxTranslateSvc.translate(name + '.DE');
            }
            // REINO UNIDO
            if (inditex.iCountryCode === 'GB') {
                res = ItxTranslateSvc.translate(name + '.GB');
            }
            return res;
        }
    }

    angular.module('itxApp.common').component('termsConditions', TermsConditionsCmp);
})();
